import _ from 'underscore';
import { FilterEntity } from '@bingads-webui/filter-entity';
import { getParameter } from '@bingads-webui/url-util';

// 2 special urls used by the UCM.
// https://ads.microsoft.com/campaign/Ads.m?filterDisapprovedAds=True&aid=123&cid=1234
// https://ads.microsoft.com/campaign/Keyword.m?filterDisapprovedKeywords=True&aid=123&cid=1234

// In the feature, may use the '&find=filterKey'in the url.
function getFilterKeyFromUrl() {
  if (getParameter('filterDisapprovedAds') === 'True') {
    return 'filterDisapprovedAds';
  }
  if (getParameter('filterDisapprovedKeywords') === 'True') {
    return 'filterDisapprovedKeywords';
  }

  return getParameter('find');
}

export function applyFilterFromUrl(filterService, urlFilterMap) {
  const filterExpression = getFilterKeyFromUrl();
  if (_.isEmpty(filterExpression)) {
    return;
  }

  let filterObject = null;

  if (_.isUndefined(urlFilterMap)) {
    filterObject = JSON.parse(filterExpression);
  } else if (_.has(urlFilterMap, filterExpression)) {
    filterObject = urlFilterMap[filterExpression];
  } else return;

  const urlFilterEntity = FilterEntity.fromLegacy(filterObject, {
    entitySchema: filterService.entitySchema,
    odata: filterService.odataOptions,
  });

  filterService.setEditableFilter(urlFilterEntity.query);
}

export function appendScopeParameter(uri, scope) {
  if (scope.values.uid) {
    uri.addQuery('uid', scope.values.uid);
  }
  if (scope.values.cid) {
    uri.addQuery('cid', scope.values.cid);
  }
  if (scope.values.aid) {
    uri.addQuery('aid', scope.values.aid);
  }
}
